import { graphqlOperation } from 'aws-amplify'

import { GRAPHQL_URL } from './config'
import { getCognitoData, makeGraphqlRequest } from '../utils'

/*
 * Queries
 */

export const startOTAUpdateQuery = async params => {
  try {
    const query = /* GraphQL */ `
      query startOTAUpdateQuery(
        $userId: String!
        $siteId: String
        $zoneIds: [String]!
        $sensorIds: [String]
        $destination: String!
      ) {
        startOTAUpdateQuery(
          userId: $userId
          siteId: $siteId
          zoneIds: $zoneIds
          sensorIds: $sensorIds
          destination: $destination
        ) {
          executionId
        }
      }
    `

    const { idToken } = await getCognitoData()
    const operation = graphqlOperation(query, params)
    const { data, error } = await makeGraphqlRequest(
      GRAPHQL_URL,
      operation,
      idToken
    )

    if (error) {
      return {
        executionId: null,
        error: `OTA update not started: ${error}`
      }
    }

    return { executionId: data?.startOTAUpdateQuery, error }
  } catch (err) {
    return { executionId: null, error: err.message }
  }
}
